import React from 'react';

import {
    Cutout
} from 'react95';

import About from '../About/about.jpg'

export const FirstAbout = () => {
    return (
        <div className="container-fluid p-0">
            <div className="row no-gutters">
                <div className="col-md-4 col-12">
                    <Cutout >
                        <img
                            style={{ width: '100%', height: 'auto', display: 'block' }}
                            src={About}
                            alt='kiwi'
                        />
                    </Cutout>
                </div>
                <div className="col-md-8 col-12">
                    <p className="px-3 py-1">
                        Hi my name is Łukasz and I am a third year student of computer science at the Polish-Japanese Academy of Computer Technology in Warsaw. In 2019 I graduated from Bootcamp Javascript Developer: React at Coders Lab programming school.
                            </p>
                    <p className="px-3">
                        I started to learn Javascript programming in 2019 and since then it has become my passion. Nowadays, I spend most of my free time improving known technologies and learning new ones.
                            </p>
                    <p className="px-3">
                        I am motivated to continue learning programming and I am enthusiastic about new projects. While creating them I try to solve the encountered problems on my own.
                            </p>
                </div>

            </div>
        </div>
    );
}